import { AlignJustify, GalleryThumbnails } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui';
import { useUrlParams } from '../../hooks';
import { TViewMode } from '../..';

const ControlsViewMode = () => {

  const { view, setValue } = useUrlParams();

  const handleOnValueChange = (value: string) =>
    setValue('view', value);

  return (
    <Tabs
      value={view}
      onValueChange={handleOnValueChange}>
      <TabsList className='grid w-full grid-cols-2'>
        <TabsTrigger
          title='Mode de vue pour visualiser les utilisateurs avec leur photo'
          className='flex items-center space-x-2'
          value={('grid') as TViewMode}>
          <GalleryThumbnails size={16} />
          <span className='text-xs'>
            Carte
          </span>
        </TabsTrigger>
        <TabsTrigger
          title='Mode de vue pour visualiser les utilisateurs en ligne de données'
          className='flex items-center space-x-2'
          value={('row') as TViewMode}>
          <AlignJustify size={16} />
          <span className='text-xs'>
            Liste
          </span>
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );

};

export default ControlsViewMode;
